import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel2';
import { useState } from 'react';
import { useEffect } from 'react';
import { getPageBySlug } from "../../services/cms.service";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { API_BASEURL } from "../../environment";

const options = {
    items: 1,
    nav: false,
    rewind: true,
    autoplay: true
};

const events = {
    onDragged: function (event) { console.log(event) },
    onChanged: function (event) { console.log(event) }
};

const RoofingContractors = () => {

    const dispatch = useDispatch();
    const location = useLocation()

    const [pageData, setPageData] = useState(null)

    useEffect(() => {
        getPageBySlug(location.pathname, (data) => {

            setPageData(data)
        }, dispatch)
    }, [])

    return (
        <>
            {pageData && <>
                <section className='hero-section'>
                    <OwlCarousel options={options} events={events} >
                        {pageData.banner_images.map(banner => {
                            return (<div className='hero-section-inner' style={{ backgroundImage: `url(${API_BASEURL}/${banner.path})` }}>
                                <div className='container'>
                                    <div className='hero-inner'>
                                        <h3 className='section-heading' dangerouslySetInnerHTML={{ __html: pageData.banner_heading }} />
                                        <p className='section-desc' dangerouslySetInnerHTML={{ __html: pageData.banner_description }} />
                                    </div>
                                </div>
                            </div>)
                        })}
                    </OwlCarousel>
                </section>
                <section className='details-section'>
                    <div className='inner-container'>
                        <div className='what-we-do-inner'>
                            <div className='btn-center-groups p-b-30'>
                                <div className='btn-el'>
                                    <Link to="/" className="btn btn-blue">Register Now</Link>
                                </div>
                                <div className='btn-el'>
                                    <Link to="/" className="btn btn-blue">Contact Us</Link>
                                </div>
                            </div>
                            <h4 className='section-heading dark text-center p-b-30' dangerouslySetInnerHTML={{ __html: pageData.page_content }} />
                            <ul className='alternate-listings'>
                                {pageData.blocks.map((block, index) => {
                                    return <li>
                                        <div className={index % 2 === 0 ? 'alternate-list-item' : 'alternate-list-item right'}>
                                            <span className='al-icon'>
                                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.2571 1.07748C30.5425 1.36148 30.3377 1.73824 29.1797 4.89782C28.0679 7.93125 28.0431 7.98321 27.68 8.03955C27.477 8.071 26.0816 8.15988 24.579 8.23698C22.3513 8.35124 21.7649 8.41875 21.4019 8.60258C20.8246 8.8952 20.4329 9.45603 20.3611 10.093C20.2546 11.0375 20.4732 11.3124 23.1626 13.617L25.6534 15.7513L24.862 18.8187C24.0076 22.13 23.9413 22.8014 24.405 23.441C24.6858 23.8283 25.4983 24.2539 25.9569 24.2539C26.5091 24.2539 26.9895 23.9852 29.4433 22.3043C30.7414 21.415 31.8854 20.6869 31.9856 20.6861C32.0858 20.6854 33.2332 21.4143 34.5354 22.3056C37.0029 23.9947 37.4657 24.2539 38.0143 24.2539C38.4729 24.2539 39.2853 23.8283 39.5662 23.441C40.0311 22.7997 39.9652 22.1299 39.111 18.8198L38.3196 15.7532L40.7345 13.6907C42.0627 12.5564 43.2465 11.4799 43.3653 11.2987C43.6927 10.7989 43.6579 9.73044 43.2978 9.22546C42.7642 8.47751 42.4138 8.38851 39.3919 8.23395C37.8895 8.15709 36.4941 8.06894 36.2911 8.03822C35.9278 7.98309 35.9039 7.93307 34.7915 4.89782C33.6198 1.70072 33.4287 1.35492 32.6759 1.07056C32.2583 0.912711 31.6639 0.915625 31.2571 1.07748ZM19.9527 29.7491C19.7257 29.8999 19.4164 30.2683 19.2651 30.5677L18.9901 31.1123L19.0222 46.412L19.0544 61.7119L19.3399 62.1709C19.4969 62.4235 19.8361 62.7376 20.0939 62.8691C20.5502 63.1019 20.8622 63.1082 31.9856 63.1082C43.109 63.1082 43.421 63.1019 43.8773 62.8691C44.1351 62.7376 44.4743 62.4235 44.6313 62.1709L44.9168 61.7119V46.2916C44.9168 30.9547 44.9154 30.869 44.6674 30.4467C44.5302 30.2132 44.2352 29.8991 44.0119 29.7485L43.6059 29.475H31.9856H20.3652L19.9527 29.7491ZM33.0343 40.1088C33.2173 40.2452 33.4795 40.5079 33.6172 40.6922C33.8595 41.0164 33.8687 41.1936 33.9017 46.1155C33.9346 51.0008 33.9262 51.2228 33.6931 51.6798C32.9949 53.0483 30.9785 53.0528 30.2819 51.6873C30.0584 51.2493 30.0429 50.9581 30.0429 47.2124V43.2062L29.7393 42.7589C29.0823 41.7907 29.5308 40.3951 30.6501 39.9258C31.1676 39.7088 32.6511 39.8226 33.0343 40.1088ZM1.87232 45.2899C1.65158 45.4402 1.35665 45.7173 1.2169 45.9058C0.965319 46.2453 0.962891 46.3246 0.962891 54.0504V61.8522L1.28999 62.2809C1.93898 63.1319 1.71885 63.1082 8.97282 63.1082C15.1231 63.1082 15.4852 63.0963 15.422 62.8957C15.1517 62.0363 15.1083 60.6938 15.1083 53.196V45.0167H8.691H2.27374L1.87232 45.2899ZM48.8622 55.6671C48.8616 60.638 48.7989 62.1104 48.5556 62.8771C48.4842 63.1023 48.648 63.1082 54.9984 63.1082C62.2522 63.1082 62.0321 63.1319 62.6812 62.2811L63.0083 61.8525L63.0425 56.82C63.0759 51.9172 63.0702 51.7739 62.8214 51.2601C62.6701 50.9475 62.3841 50.6193 62.1194 50.4548L61.6727 50.177L55.2678 50.1425L48.8629 50.1082L48.8622 55.6671Z" fill="white" />
                                                </svg>
                                            </span>
                                            <h5 dangerouslySetInnerHTML={{ __html: block.heading }} />
                                            <p dangerouslySetInnerHTML={{ __html: block.description }} />
                                        </div>
                                    </li>
                                })}
                            </ul>
                            <div className='btn-center-groups'>
                                <div className='btn-el'>
                                    <Link to="/" className="btn btn-blue">Register Now</Link>
                                </div>
                                <div className='btn-el'>
                                    <Link to="/" className="btn btn-blue">Contact Us</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>}
        </>
    )
}

export default RoofingContractors;